import {IntermediatePart} from "../../intermediatePart";
import {LOOK_OVERLAYS, ShowerBodyType} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
import store from "../../../../../store";
import {setLookOverlayOpened} from "../../../../../actions/lookFunctions";

export default class ShowerFloor extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_floor';
    this.translateId = "visualizer.bathroom.shower.shower_floor";
    this.partName = 'Floor';
    this.homePageTitle = 'Shower Flooring';
    this.dbName = 'Shower Floor';
    this.isStoneFeature = true;
    this.selectedByUser = false;
    this.layerPriority = 6;
  }

  applyFeatureIfNotCompatible() {
    const parent = this.getParent();
    const shower = parent.getParent();
    shower.showerFloorIsActive = true;
    if (shower.layout && shower.showerTubComboIsActive()) {
      const comboPart = shower.layout.parts[ShowerTubCombo.id];
      comboPart.showerTubComboIsActive = false;
    }
  }

  handleClick(ignoreLocked) {
    super.handleClick(ignoreLocked);
    if (this.notAvailableInVisualizer || getFeatureIsLocked(this)) {
      return
    }
    const parent = this.getParent();
    const shower = parent.getParent();
    if ((!shower.showerFloorIsActive || shower.showerTubComboIsActive()) && !window.location.hash.includes("visualizer")) {
      store.dispatch(setLookOverlayOpened(LOOK_OVERLAYS.notCompatiblePopup));
      return;
    }

    this.applyFeatureIfNotCompatible();

    this.getParent().selectedByUser = true;
    const threshold = shower.threshold;
    if (threshold && !threshold.selectedByUser) {
      const thresholdAvailableFeatures = threshold.navigationSubItems();
      const currentFloorName = this.getSplittedFeatureName();
      const sameThreshold = thresholdAvailableFeatures.find(tr => tr.part.getSplittedFeatureName() === currentFloorName);
      if (sameThreshold) {
        super.handleClick.call(sameThreshold.part);
        threshold.selectedByUser = false;
      }
    }
  }

  setLayers(layout) {

    if (this.getParent().showerTubComboIsActive()) {
      super.hideLayers();
      return;
    }

    if (this.getParent().customBodyType === ShowerBodyType.Door) {
      const showerDoorParent = this.getParent().showerDoor;
      if (showerDoorParent && showerDoorParent.activeFeature) {
        const currentShowerPanCondition = showerDoorParent.activeFeature.metaData["ShowerPan"];
        if (!currentShowerPanCondition || (currentShowerPanCondition && !currentShowerPanCondition.includes("Threshold"))) {
          super.hideLayers();
          return;
        }
      }
    }

    const conditions = this.getArrayOfConditions();
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(conditions)
        || (this.activeFeature.notAvailableInVisualizer && this.placeholderFeature))) {
      return super.setLayers(layout);
    }
    this.setDefault();
    return super.setLayers(layout);
  }

  getArrayOfConditions() {
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerParent = this.getParent();
    conditions.push({
      propName: "ShowerSize",
      propValue: showerParent.showerSize()
    });
    return conditions
  }
}
